import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {withRouter} from 'react-router-dom'
import {Tabs as AntTabs} from 'antd'
import Total from './Total'
import PnlByTicker from './PnlByTicker'
import TickerDetails from './TickerDetails'

import style from './style.sass'

@withRouter
@inject('store') @observer
class Tabs extends Component {
  render() {
    const {search} = this.props.history.location
    const tab = search ? search.match(/tab=([^&]*)/)[1] : 'total'
    const {backtestID} = this.props.match.params
    const {backtest} = this.props.store
    const {algo} = backtest.single
    const {tickerDetails} = backtest

    return(
      <AntTabs
        type='card'
        activeKey={tab}
        onChange={this.props.changeTab}
        styleName='wrapper'
      >
        <AntTabs.TabPane tab='Total PnL' key='total'>
          <Total id={backtestID}/>
        </AntTabs.TabPane>
        {algo.all_tickers_count > 1 &&
          <AntTabs.TabPane tab='PnL by Ticker' key='byticker'>
            <PnlByTicker id={backtestID} changeTab={this.props.changeTab}/>
          </AntTabs.TabPane>
        }
        {Object.keys(tickerDetails).map(key =>
          <AntTabs.TabPane tab={tickerDetails[key].ticker} key={tickerDetails[key].ticker}>
            <TickerDetails store={tickerDetails[key]} activeTab={tab}/>
          </AntTabs.TabPane>
        )}
      </AntTabs>
    )
  }
}

export default Tabs
